export const vracanje_isprave_vjerovniku= {
    templateId: 74,
    category: 7,
    templateTitle: 'Izjava o zapljeni po pristanku dužnika - povrat vjerovniku (ovrhovoditelju), uslijed prestanka radnog odnosa radnika',
    templateDescription: `<p>U slučaju prestanka radnog odnosa radnika kojemu je vjerovnik - ovrhovoditelj dostavio privatnu ispravu s učinkom pravomoćnog rješenju o ovrsi, poslodavac je dužan dostaviti ispravu novom poslodavcu ukoliko mu je poznat (uz obavijest vjerovniku), a ukoliko mu nije poznat, ispravu je dužan vratiti vjerovniku (ovrhovoditelju).</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Dužnik može privatnom ispravom potvrđenom kod javnog bilježnika dati suglasnost da se radi naplate tražbine vjerovnika zaplijeni njegova plaća, odnosno drugo stalno novčano primanje (suglasnost o zapljeni plaće), osim u dijelu u kojem je to primanje izuzeto od ovrhe.</p>
    <p>Isprava se izdaje u jednom primjerku te ima pravni učinak pravomoćnog rješenja o ovrsi. Ispravu s učincima dostave rješenja o ovrsi poslodavcu dostavlja vjerovnik, putem davatelja poštanskih usluga preporučenom poštanskom pošiljkom s povratnicom ili preko javnog bilježnika. Ne dostavi li se na opisani način, dostava ne proizvodi učinke dostave rješenja o ovrsi.</p>
    <p>Poslodavac ovršenika na temelju te isprave dužan je zaplijenjeni dio plaće isplatiti, odnosno isplaćivati ovrhovoditelju po isteku roka od šezdeset dana od dana njezina primitka.</p>
    <p>Ukoliko poslodavac ne može postupiti po dostavljenoj privatnoj ispravi uslijed ranijih obustava čiji iznos bi bio viši od najviše dopuštenog iznosa iz čl. 173. Ovršnog zakona, predlaže se o tome obavijestiti ovrhovoditelja prema primjeru <a class="local-link" href="/contract?template=70">ovdje</a>.
    <p>U slučaju da propustio postupiti po suglasnosti za zapljenu plaće (privatnoj ispravi), ovrhovoditelj bi mogao samo u parničnom postupku potraživati naknadu štete od poslodavca zbog neizvršavanja svojih obveza.</p>
    <p>Kod prestanka radnog odnosa radnika za kojega je zaprimio privatnu ispravu, poslodavac ima sljedeće obveze:</p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom privatnu ispravu dostaviti novom poslodavcu prema primjeru <a class="local-link" href="/contract?template=73">ovdje</a>, a potom se predlaže o izvršenoj dostavi obavijestiti vjerovnika prema primjeru <a class="local-link" href="/contract?template=73.1">ovdje</a>,   </li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom  dostaviti privatnu ispravu vjerovniku (ovrhovoditelja) prema dolje navedenom primjeru.</li>
    <br>
    <p>Ovaj primjerak obavijesti odnosi se na situaciju u kojoj se privatna isprava dostavlja (vraća) vjerovniku (ovrhovoditelju).</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku) ili slanje osnove za plaćanje krivom adresatu/primatelju</strong></p>
    <p>Pojašnjenje: budući da se neke osnove za plaćanje izdaju samo u jednom primjerku (isprava po pristanku dužnika) i da postoji rizik od nepostupanja po ispravi zbog greške poslodavca (neodašiljanje isprave na vrijeme i sl.), postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti na način određen Ovršnim zakonom te predati isprave novom poslodavcu ako mu je poznat ili vratiti vjerovniku preporučenom pošiljkom s povratnicom.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv primatelja",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
  
    title: '\r\n\r\nPREDMET: Povrat privatne isprave uslijed prestanka radnog odnosa',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
        {
            title: '',
            mandatory: false,
            dummy: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '- molim na ruke, ________________',
                    help: 'Po želji, slobodno upišite osobu kojoj želite dostaviti dopis.',
                    value: '',
                }],
        },
            
                {
                    title: '',
                    mandatory: true,
                    exampleContent: true,
                    dummy: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\nizmeđu nas kao poslodavca i radnika ____________________, iz ________________,  dana __.__._____ godine prestao je radni odnos, stoga nismo u mogućnosti postupati po dostavljenoj privatnoj ispravi. \r\nIz navedenog razloga, a budući da nam nije poznat novi poslodavac radnika, dostavljamo Vam navedenu privatnu ispravu. \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Vjerovniku (ovrhovoditelju) radnika \r\n2) Kadrovska služba',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/74_vracanje_isprave_vjerovniku.ts